export default "__VITE_ASSET__DNnp5K1S__"